import { render } from "./ChildReportDetail.vue?vue&type=template&id=42054dba&scoped=true&ts=true"
import script from "./ChildReportDetail.vue?vue&type=script&lang=ts"
export * from "./ChildReportDetail.vue?vue&type=script&lang=ts"

import "./ChildReportDetail.vue?vue&type=style&index=0&id=42054dba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42054dba"]])

export default __exports__